<template>
  <v-app>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="6" md="6" lg="6" xl="6">
            <v-row align="center" justify="center">
              <v-progress-circular
                :size="45"
                :width="4"
                class="mt-2"
                color="primary"
                indeterminate
                v-if="loading"
              />
            </v-row>
            <v-row align="center" justify="center" v-if="error.active">
              <v-card class="mx-auto" max-width="588">
                <v-row justify="center">
                  <v-img
                    align="center"
                    justify="center"
                    class="mt-12"
                    aspect-ratio="4"
                    contain
                    :transition="false"
                    :src="
                      require(`@/assets/${this.$store.getters.getLogo.path}/logo.png`)
                    "
                  />
                </v-row>
                <v-row justify="center" class="mx-4">
                  <v-card-title class="title font-weight-regular mb-2">{{
                    error.text
                  }}</v-card-title>
                </v-row>
              </v-card>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { AUTH_REQUEST_IFRAME } from "@/store/actions/auth.js";
import { mapGetters } from "vuex";
import restrictions from "@/utils/restrictions";

export default {
  name: "externalAuth",
  data() {
    return {
      loading: true,
      error: { text: "", active: false },
      allowedPages: [
        "https://www.hanseyachtsag.com",
        "https://hanseyachtsag.com",
        "https://mis.hanseyachtsag.com",
        "https://staging-mis.hanseyachtsag.com",
        "https://dev4-mis.hy.boreus.de",
        "https://stage-web.sentinelmarine.net",
        "http://localhost:8000",
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getTosAccepted",
      "getTosPartnerAccepted",
      "getIframeStatus",
    ]),
  },
  created() {
    this.setInitialData();
    window.addEventListener("message", this.externLogin);
  },
  methods: {
    setInitialData() {
      this.error = {
        text: this.$t("general.externalAuth.anErrorHasOccurred"),
        active: false,
      };
    },
    externLogin(event) {
      if (this.allowedPages.indexOf(event.origin) === -1) {
        return;
      }

      if (!event.data.token) {
        return;
      }

      this.$store
        .dispatch(AUTH_REQUEST_IFRAME, event.data.token)
        .then((resp) => {
          this.handleExternLoginSuccess(resp);
        })
        .catch((err) => {
          this.handleExternLoginError(err);
        });
    },

    handleExternLoginSuccess(resp) {
      let isVisible = [];

      for (const property in resp.menu_access) {
        isVisible.push(resp.menu_access[property].visible);
      }

      if (!this.getTosAccepted || !this.getTosPartnerAccepted) {
        return;
      }

      if (!isVisible.some((element) => element)) {
        this.$router
          .pushAsync({
            name: "new-user",
          })
          .then((resp) => {
            this.loading = false;
          })
          .catch((e) => {});
      } else {
        if (this.$route.query["next"]) {
          this.$router
            .pushAsync({
              path: this.$route.query["next"],
            })
            .then((resp) => {
              this.loading = false;
            })
            .catch((e) => {});
        } else {
          const nextRoute = restrictions.nextBaseRoute(resp);

          this.$router
            .pushAsync(nextRoute)
            .then((resp) => {
              this.loading = false;
            })
            .catch((e) => {});
        }
      }
      window.removeEventListener("message", this.externLogin);
    },
    handleExternLoginError(err) {
      this.loading = false;
      this.error.text = this.$t("general.externalAuth.anErrorHasOccurred");
      if (
        err.response.status === 403 &&
        err.response.data.error[0] === "VERIFICATION_NEEDED"
      ) {
        this.error.text = this.$t(
          "general.externalAuth.yourAccountIsBeingApprovedThisUsuallyTakesUpTo1BusinessDay"
        );
      } else if (err.response.status === 403) {
        this.error.text = this.$t(
          "general.externalAuth.youAreNotAuthorizedToAccessThisPage"
        );
      }
      this.error.active = true;
      window.removeEventListener("message", this.externLogin);
    },
  },
};
</script>
<style scoped>
.sentinel-logo--style {
  height: 81px;
  max-width: 120px;
}
</style>
